import { render, staticRenderFns } from "./PanelCompetitionClassifications.vue?vue&type=template&id=d18ca212&scoped=true&"
import script from "./PanelCompetitionClassifications.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionClassifications.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionClassifications.vue?vue&type=style&index=0&id=d18ca212&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18ca212",
  null
  
)

export default component.exports